<template>
  <BaseDelete
    :entry="entry"
    @delete-confirm-action="destroyEntry"
    @delete-cancel-action="cancelAction"
    :modelNameSingular="modelNameSingular"
    :formErrors="formErrors"
    ref="baseDelete"
    :readOnly="readOnly"
  >
    <p v-if="this.entry.customer"> Você tem certeza que deseja deletar o pedido de venda do cliente <b>{{this.entry.customer.name}}</b>?</p>
    <p v-else> Você tem certeza que deseja deletar o pedido de venda sem cliente?</p>
  </BaseDelete>
</template>

<script>
import gql from 'graphql-tag';
import BaseDelete from "@shared_components/base_delete.vue";

export default {
  data () {
    return {
      error: null,
      loading: true,
      formErrors: []
    }
  },
  components: {
    BaseDelete: BaseDelete
  },
  props: {
    entry: Object,
    readOnly: {
      type: Boolean,
      default: false
    },
    modelNameSingular: String,
  },
  methods: {
    destroyServerEntry: function(saleOrder) {
      this.loading = true;
        this.$apollo
          .mutate({
            mutation: DESTROY_SALE_ORDER_MUTATION,
            variables: {
              id: saleOrder.id,
            }
          })
          .then(response => {
            var errors = response.data.destroySaleOrder.errors
            if (errors.length){
              this.formErrors = errors
            } else {
              this.$emit("entry-destroyed");
              this.$refs.baseDelete.closeDialog();
            }
          })
          .catch(response => console.log(response))
          .finally(() => (this.loading = false));
    },
    destroyEntry: function() {
      this.destroyServerEntry(this.entry);
    },
    cancelAction: function() {
      this.$emit('entry-canceled');
    }
  }
}
const DESTROY_SALE_ORDER_MUTATION = gql `
  mutation($id: ID!) {
    destroySaleOrder(id: $id) {
      cashFlow {
        id
      }
      errors
    }
  }
`;
</script>

<style scoped></style>
